<script>
    import {video_store} from "./Utils/stores";
    import Debug from "./Utils/Debug.svelte";
    import PlaylistTile from "./PlaylistTile.svelte";
    import CategoryContainer from "./CategoryContainer.svelte";
    import CategoryContainerHeader from "./CategoryContainerHeader.svelte";
    import CategoryContainerBody from "./CategoryContainerBody.svelte";
    import CategorySidebar from "./CategorySidebar.svelte";
    import CategorySidebarTitle from "./CategorySidebarTitle.svelte";
    import CategorySidebarDescription from "./CategorySidebarDescription.svelte";
    import CategoryMainPanel from "./CategoryMainPanel.svelte";
    import CategoryGrid from "./CategoryGrid.svelte";

    let showall = false;
    function showAll() {showall = true;}
    function showFewer() {
        let section = document.getElementById('playlistTop');
        let sectionTop = section.offsetTop;
        window.scrollTo({
            top: sectionTop,
            behavior: "smooth"
        });
        showall = false;
    }

    $: if($video_store.playlists.length < 9) {showall = true;}else{showall = false;}

</script>

<CategoryContainer id="playlistTop">
    <CategoryContainerBody>
        <CategorySidebar>
            <CategorySidebarTitle>
                Learning Path Playlists
            </CategorySidebarTitle>
            <CategorySidebarDescription>
                Follow along with a set of videos to learn specific features of the software, or to achieve a particular goal.
            </CategorySidebarDescription>
        </CategorySidebar>
        <CategoryMainPanel>
            <CategoryGrid>
                {#each $video_store.playlists.slice(0,8) as playlist (playlist._id)}
                    <PlaylistTile playlist={playlist} />
                {/each}
                {#if showall}
                    {#each $video_store.playlists.slice(8) as playlist (playlist._id)}
                        <PlaylistTile playlist={playlist} />
                    {/each}
                {/if}
            </CategoryGrid>
            <div class="{(showall)?"":"vec-absolute vec-bottom-0 vec-left-0 vec-pt-[200px] vec-pointer-events-none"} vec-w-full vec-flex vec-justify-center vec-p-5 vec-bg-gradient-to-t vec-from-white">
            {#if !showall}
                <button class="vec-pointer-events-auto vec-text-center vec-bg-white vec-inline-block vec-mr-0 vec-sm:mr-3 vec-last:mr-0 vec-mb-3 vec-font-normal vec-rounded-md vec-rounded-bl-none vec-px-3 vec-py-2 vec-border hover:vec-bg-gradient-to-b hover:vec-from-white hover:vec-via-lightGrey hover:vec-to-lightGrey focus:vec-ring-4 active:vec-from-lightGrey active:vec-via-lightGrey active:vec-to-white vec-bg-none vec-text-black vec-border-darkerGrey focus:vec-ring-black/10 vec-text-md" role="button" aria-expanded="false" aria-controls="collapseExamples"
                    on:click={showAll}>
                        Show All Playlists
                </button>
            {:else}
                <button class="vec-text-center vec-bg-white vec-inline-block vec-mr-0 vec-sm:mr-3 vec-last:mr-0 vec-mb-3 vec-font-normal vec-rounded-md vec-rounded-bl-none vec-px-3 vec-py-2 vec-border hover:vec-bg-gradient-to-b hover:vec-from-white hover:vec-via-lightGrey hover:vec-to-lightGrey focus:vec-ring-4 active:vec-from-lightGrey active:vec-via-lightGrey active:vec-to-white vec-bg-none vec-text-black vec-border-darkerGrey focus:vec-ring-black/10 vec-text-md" role="button" aria-expanded="false" aria-controls="collapseExamples"
                    on:click={showFewer}>
                        Show Fewer Playlists
                </button>
            {/if}
            </div>
        </CategoryMainPanel>
    </CategoryContainerBody>
</CategoryContainer>

